import React from 'react';
import PropTypes from 'prop-types';
import PlanImpactRow from './PlanImpactRow/PlanImpactRowView';
import PlanImpactLoading from '../Loading/PlanImpactLoading';

const PlanImpactView = ({ planImpactItems, planImpactLoading }) => (
  <table className="what-ifs-layout-plan-impact plan-impact">
    <thead>
      <tr>
        <th className="label">Plan Impact</th>
        <th className="current">Current</th>
        <th className="proposed">Proposed</th>
      </tr>
    </thead>
    <tbody>
      {planImpactItems.map((item, index) => (
        <PlanImpactRow
          loadingComponent={<PlanImpactLoading />}
          isLoading={planImpactLoading && index === 0}
          key={item.label}
          label={item.label}
          current={item.current}
          proposed={item.proposed}
        />
      ))}
    </tbody>
  </table>
);

PlanImpactView.propTypes = {
  planImpactLoading: PropTypes.bool.isRequired,
  planImpactItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
    proposed: PropTypes.string.isRequired,
  })).isRequired,
};

export default PlanImpactView;
